/* PDP FAQ accordion ("faq_alternate" on the reference): reproduces its
   native <details>/<summary> behaviour --
   - Exclusive open: opening one item closes any other open item in the
     same section (matches the reference's inline toggle-event listener
     that force-closes sibling <details open> elements).
   - Reveal/collapse is instant -- only the chevron rotation animates
     (300ms cubic-bezier(0.4,0,0.2,1), set in CSS).
   - First item starts open (rendered server-side via the `is-open` class
     on the first block; this script just keeps that in sync on click). */
(function () {
  var faqSections = document.querySelectorAll('.up-pdp-faq');

  faqSections.forEach(function (section) {
    var items = section.querySelectorAll('.up-pdp-faq__item');

    items.forEach(function (item) {
      var toggle = item.querySelector('.up-pdp-faq__toggle');

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.up-pdp-faq__toggle').setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
})();
